import React, { useState, useEffect } from 'react';
import * as apis from '../../utils/apis';
import styles from '../../styles.module.scss';
import { useVendorPointSolutionContext } from '../vendor-solution-provider';
import * as helper from '../../utils/helper';
import cn from 'classnames';
import PropTypes from 'prop-types';
import toastr from '../../utils/toastr';

const ICON_GROUP = '/assets/icon_group.png';
const ICON_ORG = '/assets/icon_org.png';
const ICON_EDIT = '/assets/icon_edit.png';

const OrganizationNode = props => {
  const { org, hasBillingAccess } = props;

  const {
    selectedOrgNode,
    setSelectedOrgNode,
    selectedListOrg,
    setSelectedListOrg
  } = useVendorPointSolutionContext();

  const [orgChildren, setOrgChildren] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    isRoot,
    isChild,
    hasChildren,
    isOrg
  } = helper.getOrganizationInfo(org);

  const isSelectedNode = selectedOrgNode && selectedOrgNode.organization_id === org.organization_id;

  useEffect(() => {
    setExpanded(false);
  }, [org]);

  const fetchOrganizationChildrenById = async (id) => {
    setLoading(true);
    const orgChildren = await apis.fetchOrganizationChildrenById(id);

    if (orgChildren){
      setOrgChildren(orgChildren);
    }else {
      toastr.error('Something went wrong');
    }
  };

  const handleToggleOrgChildren = () => {
    if (!expanded && hasChildren) {
      fetchOrganizationChildrenById(org.organization_id)
        .then(() => setLoading(false));
    }

    setExpanded(!expanded);
  };

  const renderOrgChildren = () => {
    if (!expanded) {
      return;
    }
    if (loading) {
      return (
        <div className={styles.nodeChild}>
          Loading...
        </div>
      );
    }

    return orgChildren.map((child, index) => (
      <OrganizationNode
        key={`org-child-${index}-${child.organization_id}`}
        org={child}
        hasBillingAccess={hasBillingAccess}
      />
    ));
  };

  const handleSelectedOrgNode = (org) => {
    setSelectedOrgNode(org);
  };

  const handleSelectedNode = (organization) => {
    const isSelectedOrg = isSelected(organization);
    let newListOrg;

    if (isSelectedOrg) {
      newListOrg = selectedListOrg.filter(org => org.organization_id !== organization.organization_id);
    } else {
      newListOrg = [...selectedListOrg, organization];
    }

    setSelectedListOrg(newListOrg);
  };

  const isSelected = (organization) => {
    return !!selectedListOrg.find(org => org.organization_id === organization.organization_id);
  };

  return (
    <div className={isRoot ? styles.nodeRoot : styles.nodeChild}>
      {isChild && <span className={styles.connector} />}
      <div className={styles.org}>
        <a onClick={handleToggleOrgChildren}>
          <img className={styles.nodeIcon} src={isOrg ? ICON_ORG : ICON_GROUP} alt='' />
          <span className={cn(styles.orgName, isSelectedNode && styles.selectedNode)}>
            {org.organization_nm}
          </span>
        </a>
        <div className={styles.nodeOptions}>
          {hasChildren && <span>{`(${org.child_count})`}</span>}
          <img className={styles.nodeEditIcon} src={ICON_EDIT} alt='' />
          <a onClick={() => handleSelectedOrgNode(org)}>Manage VPS</a>
          {
            hasBillingAccess && !isOrg &&
            <input
              type='checkbox'
              onChange={() => handleSelectedNode(org)}
              checked={isSelected(org)}
            />
          }
        </div>
      </div>
      {renderOrgChildren()}
    </div>
  );
};

OrganizationNode.propTypes = {
  org: PropTypes.object,
  hasBillingAccess: PropTypes.bool
};

export default OrganizationNode;
